<template>
  <div class="question-editor">
    <div class="question-pd">
      <!-- 题目头部（标题+竖列设置） -->
      <div class="question-header">
        <div class="question-header-left">
          <div>
            <span v-if="isMust" class="asterisk">*</span>
            <span class="question-number">{{
              `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、`
            }}</span>
          </div>
          <div class="question-select">
            <span>矩阵单选</span>
          </div>
          <div class="question-header-right" style="margin-left: 10px">
            <div class="required custom-check-box">
              <div class="question-operate" @click="showVerticalNum = true">
                竖列显示：{{ verticalNum }}
              </div>
            </div>
          </div>
        </div>
        <div class="question-header-right">
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596666801.png"
            lazy-load
            class="image-up"
            @click="handleOperateClick(2)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596715787.png"
            lazy-load
            class="image-down"
            @click="handleOperateClick(3)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596748508.png"
            lazy-load
            class="image-delete"
            @click="handleOperateClick(4)"
          />
        </div>
      </div>

      <!-- 题目描述输入框 -->
      <div
        class="textarea-box"
        :style="{
          border:
            isFocusIndex === '-1'
              ? '1px solid rgba(58,96,255,0.5)'
              : '1px solid #DCDDE0',
        }"
      >
        <!-- <textarea
          class="case-problem-textarea textarea-placeholder"
          v-model="caseProblem"
          placeholder="请输入标题"
          maxlength="500"
          :disabled="dataObj.disabled"
          @focus="isFocusIndex = '-1'"
          @blur="isFocusIndex = ''"
          @input="handleUpdate"
        ></textarea>
        <div class="textarea-footer">
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737857957020.png"
            style="width: 18px; height: 18px; cursor: pointer"
            @click="handleCaseProblemImg"
          />
          <div @click="clearQuestion" class="clear-btn">清空</div>
        </div> -->
        <MyEditor
          v-model="caseProblem"
          placeholder="请输入标题"
          @insertImg="handleCaseProblemImg"
          @input="handleInput"
        />
      </div>

      <!-- 题目图片展示 -->
      <div class="question-images">
        <div
          v-for="(item, index) in images"
          :key="index"
          style="margin-top: 10px; position: relative"
        >
          <img :src="item" style="width: 100%; border-radius: 4px" />
          <img
            src="@/assets/images/guanbi.png"
            class="guanbi"
            @click="handleDeleteQuestionImage(index)"
            style="width: 20px; height: 20px; cursor: pointer"
          />
        </div>
      </div>

      <!-- 矩阵标题编辑区域 -->
      <div class="matrix-header">
        <div class="matrix-header-item">
          <textarea
            v-model="horizontalTitle"
            :placeholder="'横标题'"
            maxlength="500"
            @input="(e) => handleInputTitle(e, -1)"
            class="matrix-textarea"
          ></textarea>
        </div>
        <div
          class="matrix-header-item"
          v-for="(col, colIndex) in percentageTitles"
          :key="colIndex"
        >
          <textarea
            v-model="col.text"
            placeholder="竖标题"
            maxlength="500"
            @input="(e) => handleInputTitle(e, colIndex)"
            class="matrix-textarea"
          ></textarea>
        </div>
      </div>

      <!-- 矩阵选项区域 -->
      <div v-for="(option, index) in list" :key="index" class="matrix-options">
        <div class="matrix-options-item">
          <textarea
            v-model="option.context"
            :placeholder="'标题' + (index + 1)"
            maxlength="500"
            @input="handleUpdate"
            class="matrix-textarea"
          ></textarea>
          <!-- <el-input
            type="textarea"
            resize="none"
            placeholder="请输入内容"
            :placeholder="'标题' + (index + 1)"
            v-model="option.context"
          >
          </el-input> -->
        </div>
        <div
          class="matrix-options-item"
          v-for="(col, colIndex) in percentageTitles"
          :key="colIndex"
        >
          <el-checkbox size="mini"></el-checkbox>
        </div>
        <img
          v-if="index > 1"
          src="@/assets/images/guanbi.png"
          class="guanbi option-del"
          @click="handleDeleteQuestionOption(index)"
          style="width: 20px; height: 20px; cursor: pointer"
        />
      </div>

      <!-- 操作区域（必选题+添加选项） -->
      <div class="add-view">
        <div class="required custom-check-box">
          <el-checkbox
            v-model="isMust"
            label="必选题"
            size="mini"
            label-class-name="checkbox-label"
          ></el-checkbox>
        </div>
        <div @click="addOption" class="add-btn">
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737858857723.png"
            style="width: 12.5px; height: 12.5px"
          />
          <span>添加选项 {{ list.length + "/50" }}</span>
        </div>
        <div class="add-batch custom-check-box" style="color: #ffffff">
          添加选项
        </div>
      </div>
    </div>

    <div class="option-settings">
      <div class="question-header-right">
        <div class="add-batch" @click="handleShowScore">
          <span>分值设置：{{ totalScore }}分</span>
        </div>
      </div>
      <div></div>
    </div>

    <!-- 底部按钮 -->
    <div v-if="type === 1" class="question-footer">
      <!-- <div class="cancel-btn" @click="cancelClick">取消</div> -->
      <div class="save-btn" @click="saveClick">保存</div>
    </div>

    <!-- 竖列数量选择弹窗（替代up-picker） -->
    <el-dialog
      title="选择竖列数量"
      :visible.sync="showVerticalNum"
      width="25%"
      @close="showVerticalNum = false"
      custom-class="vertical-dialog"
    >
      <el-select
        v-model="verticalNumTemp"
        placeholder="请选择"
        style="width: 100%"
      >
        <el-option label="2列" value="2"></el-option>
        <el-option label="3列" value="3"></el-option>
      </el-select>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showVerticalNum = false">取消</el-button>
        <el-button type="primary" @click="handleVerticalNumConfirm"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="showScore"
      title="分值设置"
      width="500px"
      style="margin-top: 22vh"
    >
      <div class="score-dialog-body">
        <div v-for="(item, index) in scoreList" :key="index" class="score-item">
          <span class="score-text">{{ item.text }}</span>
          <!-- <Stepper
            :initialValue="item.score"
            :decimalDigits="1"
            :step="0.5"
            :minValue="0"
            :maxValue="1000"
            @update="handleStepperUpdate($event, index)"
            :key="index"
          /> -->
          <el-input-number
            v-model="item.score"
            :precision="1"
            :step="0.5"
            :min="0"
            :max="1000"
            @change="handleStepperUpdate($event, index)"
            size="medium"
            class="vertical-input"
          ></el-input-number>
        </div>
      </div>
      <div class="question-footer">
        <div class="save-btn" @click.stop="confirmClick">保存</div>
      </div>
    </el-dialog>

    <!-- 隐藏的文件上传框（替代uploadImage组件） -->
    <input
      type="file"
      ref="fileInput"
      accept="image/*"
      style="display: none"
      @change="handleFileChange"
    />
  </div>
</template>

<script>
import axios from "axios";
import baseURL from "../../utils/bsaeUrl";

export default {
  name: "QuestionMatrixCheckbox",
  // Vue2 定义Props
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0,
    },
    updateType: {
      type: Number,
      default: 0,
    },
    type: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      list: [],
      dataObj: {},
      ifRandomize: false,
      isMust: false,
      showpopup: false,
      showUpload: false,
      uploadIndex: 0,
      images: [],
      caseProblem: "",
      isFocusIndex: "",
      inputFocusIndex: "",
      verticalNum: 3, // 竖列 2-3
      showVerticalNum: false, // 是否显示竖列选择弹窗
      defaultVerticalNum: [1], // 默认竖列 2-3
      horizontalTitle: "横标题",
      percentageTitles: [{ text: "满意" }, { text: "不满意" }],
      numColumns: [
        [
          { id: 2, label: "2" },
          { id: 3, label: "3" },
        ],
      ],
      // 竖列数量临时变量（弹窗用）
      verticalNumTemp: "2",
      // 替代 Vue3 ref
      fangdaShow: false,
      fangdaImgUrl: "",
      fangdaTitle: "",
      totalScore: 0,
      showScore: false,
      scoreList: [],
      scoreData: [],
    };
  },
  // Vue2 监听属性
  watch: {
    // 监听dataObj变化
    params: {
      handler(newValue) {
        console.log("newValuedokfeeje0r320hiofhhiofheiowfhewio", newValue);
        this.dataObj = { ...newValue };
        this.caseProblem = newValue.caseProblem || "";

        // 解析选项列表
        const chooseList = JSON.parse(
          newValue.chooseList ||
            '{"list":[],"verticalNum":3,"percentageTitle":"满意,不满意","horizontalTitle":"横标题"}',
        );
        this.list = chooseList.list || [];
        this.verticalNum = chooseList.verticalNum || 2;
        // || "横标题"
        this.horizontalTitle = chooseList.horizontalTitle;

        // 解析竖列标题
        // this.percentageTitles = (chooseList.percentageTitle || "满意,不满意")
        //   .split(",")
        //   .map((item) => ({ text: item }));
        const titles = (chooseList.percentageTitle || "")
          .split(",")
          .filter((item) => item !== "");
        const count = Math.max(titles.length, 3);
        this.percentageTitles = Array.from({ length: count }).map((_, i) => ({
          text: titles[i] || "",
        }));

        console.log("this.percentageTitles9999999999", this.percentageTitles);

        // 将第361行的错误赋值改为：
        this.scoreData =
          JSON.parse(newValue.chooseList).percentageTitleScore.split(",") || [];
        this.totalScore =
          (this.scoreData.length > 0 ? Math.max(...this.scoreData) : 0) *
            this.list.length || 0;

        this.isMust = newValue.isMust === 1;
        this.images = JSON.parse(newValue.caseProblemImg || "[]");

        // 同步临时变量
        this.verticalNumTemp = this.verticalNum + "";
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleFileChange(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("file", file); // "file" 对应后端接收的字段名
      formData.append("uuid", this.uuid);

      // 清空文件选择框
      this.$refs.fileInput.value = "";
      axios
        .post(baseURL + "/PCwj/file/uploads", formData, {
          headers: {
            "Content-Type": "multipart/form-data", // 必须设置
            token: localStorage.getItem("token"),
          },
        })
        .then((response) => {
          this.$message.success("上传成功！");
          this.images = [response.data.urls];
          this.handleUpdate();
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            console.log("上传已取消:", error.message);
          } else {
            this.$message.error("上传失败！");
          }
        });
    },
    handleOperateClick(type) {
      this.$emit(
        "operate",
        JSON.stringify({
          type: type,
          index: this.index,
        }),
      );
    },
    // 删除矩阵选项
    handleDeleteQuestionOption(index) {
      this.list.splice(index, 1);
      this.handleUpdate();
    },
    // 添加矩阵选项
    addOption() {
      if (this.list.length < 50) {
        this.list.push({
          id: "", // 选项ID
          context: "",
        });
        this.handleUpdate();
      } else {
        this.$message.warning("最多只能添加50个选项");
      }
    },
    // 触发题目图片上传
    handleCaseProblemImg() {
      this.uploadIndex = -1;
      this.$refs.fileInput.click(); // 触发文件选择框
    },
    // 兼容原上传组件回调
    handleUploadComplete(e) {
      if (this.uploadIndex === -1) {
        this.images = e;
      }
      this.showUpload = false;
      this.handleUpdate();
    },
    // 删除题目图片
    handleDeleteQuestionImage(index) {
      this.images.splice(index, 1);
      this.handleUpdate();
    },
    // 清空题目描述
    clearQuestion() {
      this.caseProblem = "";
      this.handleUpdate();
    },
    // 取消按钮
    cancelClick() {
      this.$emit(
        "cancel",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    // 保存按钮
    saveClick() {
      const titles = ["满意", "不满意", "中立"];
      // 组装保存数据
      this.dataObj.isMust = this.isMust ? 1 : 0;
      this.dataObj.caseProblemImg = JSON.stringify(this.images);
      this.dataObj.ifRandomize = this.ifRandomize ? 1 : 0;
      this.dataObj.caseProblem = this.caseProblem || "请输入标题";
      this.dataObj.chooseList = JSON.stringify({
        list: this.list.map((temp, idx) => ({
          ...temp,
          context: temp.context === "" ? "标题" + (idx + 1) : temp.context,
        })),
        verticalNum: this.verticalNum,
        percentageTitle: this.percentageTitles
          .map((item) => item.text)
          .map((title, titIdx) => title.trim() || titles[titIdx])
          .slice(0, parseInt(this.verticalNum))
          .join(","),
        horizontalTitle: this.horizontalTitle || "横标题",
        percentageTitleScore: this.scoreData.join(","),
      });

      // 触发保存事件
      this.$emit(
        "save",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    // 处理矩阵标题输入（限制5字）
    handleInputTitle(e, index) {
      const value = e.target.value;
      if (index === -1) {
        // 横标题
        if (value.length > 5) {
          this.horizontalTitle = value.slice(0, 5);
        }
      } else {
        // 竖列标题
        if (value.length > 5) {
          this.percentageTitles[index].text = value.slice(0, 5);
        }
      }
      this.handleUpdate();
    },
    // 实时更新事件
    handleUpdate() {
      console.log("f8h8fhe8ewh8g9wegh89ehg89w", this.caseProblem);

      this.dataObj.isMust = this.isMust ? 1 : 0;
      this.dataObj.caseProblemImg = JSON.stringify(this.images);
      this.dataObj.ifRandomize = this.ifRandomize ? 1 : 0;
      this.dataObj.caseProblem = this.caseProblem;
      this.dataObj.chooseList = JSON.stringify({
        list: this.list,
        verticalNum: this.verticalNum,
        percentageTitle: this.percentageTitles
          .map((item) => item.text)
          .join(","),
        horizontalTitle: this.horizontalTitle,
        percentageTitleScore: this.scoreData.join(","),
      });
      this.dataObj.questionScore = this.totalScore;

      this.$emit(
        "update",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    // 确认竖列数量选择
    handleVerticalNumConfirm() {
      this.verticalNum = parseInt(this.verticalNumTemp);
      this.showVerticalNum = false;

      // 更新竖列标题
      if (this.verticalNum === 2) {
        this.percentageTitles = [{ text: "满意" }, { text: "不满意" }];
      } else if (this.verticalNum === 3) {
        this.percentageTitles = [
          { text: "满意" },
          { text: "不满意" },
          { text: "中立" },
        ];
      }
      this.handleUpdate();
    },
    // 图片预览（保留方法，可根据需要扩展）
    showBigImage(img, option) {
      this.fangdaShow = true;
      this.fangdaImgUrl = img;
      this.fangdaTitle = option.text || "";
    },
    fangdaClose() {
      this.fangdaShow = false;
      this.fangdaImgUrl = "";
      this.fangdaTitle = "";
    },
    handleInput() {},
    handleShowScore() {
      this.scoreList = this.percentageTitles.map((item, index) => {
        return {
          ...item,
          text: item.text === "" ? "竖标题" : item.text,
          score: this.scoreData[index] || 0,
        };
      });
      this.showScore = true;
    },
    handleStepperUpdate(e, index) {
      console.log("feihfegf2gfi23gf32gf23ufg2", e);
      this.scoreList[index].score = e;
      this.scoreData[index] = e;
    },
    confirmClick() {
      console.log("this.scoreList", this.scoreList);
      this.list = this.list.map((item, index) => ({
        ...item,
      }));
      // state.scoreData最大值
      this.totalScore = Math.max(...this.scoreData) * this.list.length;
      this.handleUpdate();
      this.showScore = false;
    },
  },
};
</script>

<style lang="scss" scoped>
// 基础样式重置
* {
  box-sizing: border-box;
}

.question-editor {
  width: 100%;
  // padding: 10px;
  // background: #f5f5f5;
}

.question-pd {
  width: 100%;
}

// 题目头部
.question-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px; // 20rpx → 10px
}

.question-header-left {
  display: flex;
  align-items: center;
}

.asterisk {
  color: #ff4d4f;
  margin-right: 4px; // 8rpx → 4px
}

.question-number {
  margin-right: 6px; // 12rpx → 6px
  color: #666;
  font-size: 14px;
}

.question-select {
  background: #f0f0f0;
  padding: 3px 6px; // 6rpx 12rpx → 3px 6px
  border-radius: 2px; // 4rpx → 2px
  color: #666;
  font-size: 13px; // 26rpx → 13px
}

// 题目描述输入框
.textarea-box {
  width: 100%;
  background: #ffffff;
  border: 1px solid #dcdde0;
  border-radius: 4px; // 8rpx → 4px
  padding: 7px 8px 5px; // 14rpx 16rpx 10rpx → 7px 8px 5px
  margin-top: 11px; // 22rpx → 11px
  margin-bottom: 10px; // 20rpx → 10px

  .case-problem-textarea {
    width: 100%;
    min-height: 40px; // 80rpx → 40px
    border: none;
    outline: none;
    resize: none;
    font-size: 14px; // 28rpx → 14px
    color: #333;
  }

  .textarea-placeholder::placeholder {
    color: #999;
  }

  .textarea-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 4px; // 8rpx → 4px
  }
}

// 清空按钮
.clear-btn {
  width: 31px; // 62rpx → 31px
  height: 18px; // 36rpx → 18px
  background: #ffffff;
  border: 1px solid #3a60ff; // 1rpx → 1px
  border-radius: 2.5px; // 5rpx → 2.5px
  font-size: 11px; // 22rpx → 11px
  font-weight: 400;
  text-align: center;
  color: #3a60ff;
  line-height: 18px; // 36rpx → 18px
  margin-left: 5.5px; // 11rpx → 5.5px
  cursor: pointer;
}

// 题目图片区域
.question-images {
  margin-bottom: 10px; // 20rpx → 10px

  .guanbi {
    position: absolute;
    top: -5px; // -10rpx → -5px
    right: -5px; // -10rpx → -5px
    z-index: 10;
  }
}

// 矩阵标题样式
.matrix-header {
  display: flex;
  margin-bottom: 10px; // 20rpx → 10px
  box-sizing: border-box;
  width: 100%;
}

.matrix-header-item {
  flex: 1;
  margin-left: 10px; // 20rpx → 10px
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #dcdde0;
  border-radius: 4px; // 8rpx → 4px

  &:first-child {
    flex: 2;
    margin-left: 0;
  }

  textarea {
    width: 100%;
    // padding: 5px 10px; // 10rpx 20rpx → 5px 10px
    font-size: 14px; // 28rpx → 14px
    color: #2b2f36;
    resize: none;
    outline: none;
    border: none;
    // min-height: 16px; // 32rpx → 16px
    height: 0;
    line-height: 24px;

    &::placeholder {
      line-height: 24px;
    }
  }
}

.matrix-textarea {
  width: 100%;
  padding: 3px; // 6rpx → 3px
  border: 1px solid #dcdde0;
  border-radius: 4px; // 8rpx → 4px
  text-align: center;
  font-size: 14px; // 28rpx → 14px
  color: #4c4a56;
  resize: none;
  outline: none;
  min-height: 30px;
}

// 矩阵选项样式
.matrix-options {
  display: flex;
  margin-bottom: 10px; // 20rpx → 10px
  box-sizing: border-box;
  align-items: center;
  position: relative;
  border: 1px dashed #3a60ff; // 1rpx → 1px
  border-radius: 2.5px; // 5rpx → 2.5px
  padding: 5px;
}

.matrix-options-item {
  flex: 1;
  margin-left: 10px; // 20rpx → 10px
  display: flex;
  justify-content: center;
  align-items: center;

  &:first-child {
    flex: 2;
    margin-left: 0;
  }

  textarea {
    width: 100%;
    padding: 0px 10px; // 10rpx 20rpx → 5px 10px
    font-size: 14px; // 28rpx → 14px
    color: #2b2f36;
    resize: none;
    outline: none;
    border: none;
    // min-height: 16px; // 32rpx → 16px
    min-height: 24px;
    height: 0;
    line-height: 24px;
  }
}

.option-del {
  position: absolute;
  top: 5px; // 10rpx → 5px
  right: 5px; // 10rpx → 5px
  width: 20px; // 40rpx → 20px
  height: 20px; // 40rpx → 20px
}

// 操作区域
.add-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
}

.add-btn {
  width: 153px; // 306rpx → 153px
  height: 32px; // 64rpx → 32px
  background: #ffffff;
  border: 1px solid #00c755; // 2rpx → 1px
  border-radius: 20px; // 40rpx → 20px
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  cursor: pointer;

  span {
    font-size: 14px; // 28rpx → 14px
    color: #00c755;
    margin-left: 11px; // 22rpx → 11px
  }
}

// 题目头部右侧
.question-header-right {
  .required {
    margin-right: 5px; // 10rpx → 5px
    font-size: 14px; // 28rpx → 14px
    color: #3a60ff;
    display: flex;
    align-items: center;
    gap: 10px; // 20rpx → 10px
    border-bottom: 1px solid #3a60ff; // 2rpx → 1px
    cursor: pointer;
  }
}

// 隐藏上传框
.hidden-upload {
  display: none;
}

// 复选框标签样式
.checkbox-label {
  font-size: 14px;
  color: #2b2f36;
}

.question-header-right {
  display: flex;
  align-items: center;

  .add-batch {
    border-bottom: 1px solid #3a60ff;
  }
}

.score-dialog-body {
  max-height: 400px;
  overflow-y: auto;
}

.score-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding: 10px 0;
  border-bottom: 1px solid #e7e7e7;
}

.score-text {
  flex: 1;
  flex-shrink: 1;
  min-width: 0;
  font-size: 14px;
  font-weight: 400;
  color: #2b2f36;
  margin-right: 10px;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
  text-align: left;
}
</style>
<style>
.vertical-dialog .el-dialog__body {
  padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/EvaluationEdit/EvaluationEditMatrixScq.vue